import React, { useState, useEffect } from 'react';
import styles from './AddCoBroker.module.scss';
import CustomButton from '../../../../layout/customButton/CustomButton';
import { createCoBroker } from '../../../../../api/Siteplan/createCoBroker.api';
import { updateCoBroker } from '../../../../../api/Siteplan/updateCoBroker.api';
import {
	TextField,
	FormControl,
	InputLabel,
	OutlinedInput,
	FormHelperText,
} from '@material-ui/core';
import SitePlanImgMapper from '../../../siteplanSection/lots/siteplanImgMapper/siteplanImgMapper';
import { connect } from 'react-redux';
import { setLotsSelected } from '../../../../../redux/siteplanManagement/action';
import AssignLots from './assignLots/AssignLots';
import { setAlert } from '../../../../../redux/alerts/action';
import {
	reformatPhoneString,
	removeAlphabeticalCharWithMaxLength,
	validatePhoneNumber,
} from '../../../../../utils/validatePhoneNumber';
import { validateEmail } from '../../../../../utils/validateEmail';

const AddCoBroker = (props) => {
	const [salesAgency, setSalesAgency] = useState('');
	const [email, setEmail] = useState('');
	const [address, setAddress] = useState('');
	const [phoneNumber, setPhoneNumber] = useState('');
	const [agentName, setAgentName] = useState('');
	const [commissionPercentage, setCommissionPercentage] = useState('');
	const [coCrokerUserId, setCoCrokerUserId] = useState('');
	const [saleAgencyError, setSaleAgencyError] = useState(false);
	const [saleAgencyErrorMsg, setSaleAgencyErrorMsg] = useState('');
	const [emailError, setEmailError] = useState(false);
	const [emailErrorMsg, setEmailErrorMsg] = useState('');
	const [addressError, setAddressError] = useState(false);
	const [addressErrorMsg, setAddressErrorMsg] = useState('');
	const [phoneNumberError, setPhoneNumberError] = useState(false);
	const [phoneNumberErrorMsg, setPhoneNumberErrorMsg] = useState('');
	const [agentNameError, setAgentNameError] = useState(false);
	const [agentNameErrorMsg, setAgentNameErrorMsg] = useState('');
	const [commissionPercentageError, setCommissionPercentageError] =
		useState(false);
	const [commissionPercentageErrorMsg, setCommissionPercentageErrorMsg] =
		useState('');
	const [numberOfLots, setNumberOfLots] = useState('1');
	const [numberOfLotsError, setNumberOfLotsError] = useState(false);
	const [numberOfLotsErrorMsg, setNumberOfLotsErrorMsg] = useState('');

	const {
		closeAddCoBrokerModal,
		lotsSelected,
		editCoBrokerId,
		lots,
		coBrokers,
		setLotsSelected,
		setAlert,
		modalOpen,
	} = props;

	useEffect(() => {
		if (editCoBrokerId) {
			setLotsSelected({});
			let coBroker;
			let filteredCoBroker = coBrokers.filter(
				(coBroker) => coBroker.coBrokerId === editCoBrokerId
			);
			if (filteredCoBroker.length > 0) {
				coBroker = filteredCoBroker[0];
				let filteredLots = lots.filter(
					(lot) =>
						lot.assignedCoBroker &&
						lot.assignedCoBroker === editCoBrokerId
				);
				let assignedLots = [];
				let lotsObj = {};
				if (filteredLots.length > 0) {
					assignedLots = filteredLots.map(
						(filteredLot) => filteredLot.lot
					);
				}
				if (assignedLots.length > 0) {
					assignedLots.forEach((lotId) => {
						lotsObj[lotId] = true;
					});
					setLotsSelected(lotsObj);
				}
			}

			setSalesAgency(coBroker?.salesAgency ? coBroker.salesAgency : '');
			setAgentName(coBroker?.name ? coBroker.name : '');
			setEmail(coBroker?.email ? coBroker.email : '');
			setPhoneNumber(coBroker?.phoneNumber ? coBroker.phoneNumber : '');
			setAddress(coBroker?.address ? coBroker.address : '');
			setCommissionPercentage(
				coBroker?.commissionPercentage
					? coBroker.commissionPercentage
					: ''
			);
			setNumberOfLots(
				coBroker?.numberOfLotsAllowed
					? coBroker.numberOfLotsAllowed
					: '1'
			);
			setCoCrokerUserId(coBroker?.userId ? coBroker.userId : '');
		} else {
			setLotsSelected({});
			setSalesAgency('');
			setAgentName('');
			setEmail('');
			setPhoneNumber('');
			setAddress('');
			setCommissionPercentage('');
			setNumberOfLots('1');
		}
	}, [editCoBrokerId, modalOpen]);

	const handelChange = (e) => {
		let value = e.target.value;
		if (e.target.name === 'salesAgency') {
			setSalesAgency(value);
		} else if (e.target.name === 'email') {
			setEmail(value);
			clearEmailError();
		} else if (e.target.name === 'address') {
			setAddress(value);
		} else if (e.target.name === 'phoneNumber') {
			let phoneNum = removeAlphabeticalCharWithMaxLength(value);
			if (validatePhoneNumber(phoneNum)) {
				value = reformatPhoneString(phoneNum);
			} else {
				value = phoneNum;
			}
			setPhoneNumber(value);
			clearPhoneNumberError();
		} else if (e.target.name === 'agentName') {
			setAgentName(value);
			clearAgentNameError();
		} else if (e.target.name === 'commissionPercentage') {
			setCommissionPercentage(value);
			clearCommissionPercentageError();
		} else if (e.target.name === 'numberOfLots') {
			setNumberOfLots(value);
			clearNumberOfLotsError();
		}
	};

	const handleSubmit = () => {
		if (
			agentName.length === 0 ||
			!validateCommissionPercentage(commissionPercentage) ||
			!validateNumberOfLots(numberOfLots) ||
			!validateAssignedLots() ||
			!validatePhoneNumber(phoneNumber) ||
			!validateEmail(email)
		) {
			if (agentName.length === 0) {
				setAgentNameError(true);
				setAgentNameErrorMsg('Name is required.');
			}
			if (!validateCommissionPercentage(commissionPercentage)) {
				setCommissionPercentageError(true);
				setCommissionPercentageErrorMsg(
					'Commission Percentage is not a valid number.'
				);
			}
			if (!validateNumberOfLots(numberOfLots)) {
				setNumberOfLotsError(true);
				setNumberOfLotsErrorMsg('Invalid number.');
			}
			if (!validateAssignedLots()) {
				setAlert('error', 'Please assign more units.');
			}
			if (!validatePhoneNumber(phoneNumber)) {
				setPhoneNumberError(true);
				setPhoneNumberErrorMsg('Invalid phone number.');
			}
			if (!validateEmail(email)) {
				setEmailError(true);
				setEmailErrorMsg('Invalid email address.');
			}
		} else {
			let lostsSelectedArr = getLostsSelectedArr();
			let numberOfLotsAllowed;
			if (Number(numberOfLots) < lostsSelectedArr.length) {
				setNumberOfLots(lostsSelectedArr.length);
				numberOfLotsAllowed = lostsSelectedArr.length;
			} else {
				numberOfLotsAllowed = Number(numberOfLots);
			}
			if (editCoBrokerId) {
				updateCoBroker(editCoBrokerId, {
					salesAgency: salesAgency,
					name: agentName,
					email: email,
					phoneNumber: phoneNumber,
					address: address,
					commissionPercentage: Number(commissionPercentage),
					numberOfLotsAllowed: numberOfLotsAllowed,
					assignedLots: lostsSelectedArr,
					userId: coCrokerUserId,
				});
				closeAddCoBrokerModal();
			} else {
				createCoBroker({
					email: email,
					name: agentName,
					phoneNumber: phoneNumber,
					address: address,
					commissionPercentage: Number(commissionPercentage),
					assignedLots: lostsSelectedArr,
					numberOfLotsAllowed: numberOfLotsAllowed,
					salesAgency: salesAgency,
				})
					.then(() => {
						closeAddCoBrokerModal();
					})
					.catch((error) => {
						setAlert('error', error.message);
					});
			}
		}
	};

	const validateCommissionPercentage = (number) => {
		if (isNaN(number)) {
			return false;
		} else {
			if (number >= 0 && number <= 100) {
				return true;
			} else {
				return false;
			}
		}
	};

	const validateNumberOfLots = (number) => {
		if (isNaN(number)) {
			return false;
		} else {
			if (number > 0 && Number.isInteger(Number(number))) {
				return true;
			} else {
				return false;
			}
		}
	};

	const validateAssignedLots = () => {
		let lotsSelectedArr = getLostsSelectedArr();
		if (
			lotsSelectedArr.length !== 0 &&
			lotsSelectedArr.length < numberOfLots
		) {
			return false;
		} else {
			return true;
		}
	};

	const clearAgentNameError = () => {
		if (agentNameError) {
			setAgentNameError(false);
			setAgentNameErrorMsg('');
		}
	};

	const clearCommissionPercentageError = () => {
		if (commissionPercentageError) {
			setCommissionPercentageError(false);
			setCommissionPercentageErrorMsg('');
		}
	};

	const clearNumberOfLotsError = () => {
		if (numberOfLotsError) {
			setNumberOfLotsError();
			setNumberOfLotsErrorMsg('');
		}
	};

	const clearPhoneNumberError = () => {
		if (phoneNumberError) {
			setPhoneNumberError();
			setPhoneNumberErrorMsg('');
		}
	};

	const clearEmailError = () => {
		if (emailError) {
			setEmailError();
			setEmailErrorMsg('');
		}
	};

	const handleSubtract = () => {
		if (validateNumberOfLots(numberOfLots)) {
			clearNumberOfLotsError();
			setNumberOfLots(Number(numberOfLots) - 1);
		} else {
			setNumberOfLotsError(true);
			setNumberOfLotsErrorMsg('Invalid number.');
		}
	};

	const handlePlus = () => {
		if (validateNumberOfLots(numberOfLots)) {
			clearNumberOfLotsError();
			setNumberOfLots(Number(numberOfLots) + 1);
		} else {
			setNumberOfLotsError(true);
			setNumberOfLotsErrorMsg('Invalid number.');
		}
	};

	const getLostsSelectedArr = () => {
		let lotIdArr = Object.keys(lotsSelected).filter(
			(lotId) => lotsSelected[lotId]
		);
		return lotIdArr;
	};

	return (
		<div className={styles.add_broker_form}>
			<div className={styles.form_group}>
				<TextField
					name='salesAgency'
					variant='outlined'
					label='Sales Agency'
					className={styles.form_item}
					value={salesAgency}
					onChange={handelChange}
					error={saleAgencyError}
					helperText={saleAgencyErrorMsg}
				/>
				<TextField
					name='email'
					variant='outlined'
					label='Email Address'
					className={styles.form_item}
					value={email}
					onChange={handelChange}
					error={emailError}
					helperText={emailErrorMsg}
				/>
			</div>
			<div className={styles.form_group}>
				<TextField
					name='address'
					variant='outlined'
					label='Address'
					className={styles.form_item}
					value={address}
					onChange={handelChange}
					error={addressError}
					helperText={addressErrorMsg}
				/>
				<TextField
					name='phoneNumber'
					variant='outlined'
					label='Phone Number'
					className={styles.form_item}
					value={phoneNumber}
					onChange={handelChange}
					error={phoneNumberError}
					helperText={phoneNumberErrorMsg}
				/>
			</div>
			<div className={styles.form_group}>
				<TextField
					name='agentName'
					variant='outlined'
					label='Agent Name'
					className={styles.form_item}
					value={agentName}
					onChange={handelChange}
					error={agentNameError}
					helperText={agentNameErrorMsg}
				/>
				<TextField
					name='commissionPercentage'
					variant='outlined'
					label='Commission %'
					className={styles.form_item}
					value={commissionPercentage}
					onChange={handelChange}
					error={commissionPercentageError}
					helperText={commissionPercentageErrorMsg}
				/>
			</div>
			<div className={styles.form_group}>
				<FormControl
					variant='outlined'
					className={styles.form_item}
					error={numberOfLotsError}
				>
					<InputLabel htmlFor='number-lots'>
						Number of Units
					</InputLabel>
					<OutlinedInput
						id='number-lots'
						className={styles.number_of_lots}
						name='numberOfLots'
						value={numberOfLots}
						labelWidth={130}
						onChange={handelChange}
						inputProps={{
							autoComplete: 'off',
						}}
						startAdornment={
							<div
								className={
									numberOfLots == '1'
										? styles.disabled_btn
										: ''
								}
							>
								<CustomButton
									width={38}
									height={37}
									onClick={handleSubtract}
									disabled={numberOfLots == '1'}
								>
									-
								</CustomButton>
							</div>
						}
						endAdornment={
							<div>
								<CustomButton
									width={38}
									height={37}
									onClick={handlePlus}
								>
									+
								</CustomButton>
							</div>
						}
					/>
					<FormHelperText id='component-error-text'>
						{numberOfLotsErrorMsg}
					</FormHelperText>
				</FormControl>
				<div className={styles.form_item}></div>
			</div>
			<div className={styles.assign_lot}>
				<div className={styles.models}>
					<AssignLots />
				</div>
				<div className={styles.lots}>
					<SitePlanImgMapper stayHighlighted={true} />
					<div className={styles.submit_btn}>
						<CustomButton
							width={166}
							height={42}
							onClick={handleSubmit}
						>
							Submit
						</CustomButton>
					</div>
				</div>
			</div>
		</div>
	);
};

const mapStateToProps = (state) => ({
	lotsSelected: state.siteplanManagement.lotsSelected,
	lots: state.siteplanManagement.lots,
	coBrokers: state.siteplanManagement.coBrokers,
});
export default connect(mapStateToProps, { setLotsSelected, setAlert })(
	AddCoBroker
);
